// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WhatsappMessageTemplates_BuscaTemplatePorNomeResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/whatsapp_message_templates/busca_template_por_nome/{template_name}.
 *
 * Returns a single WhatsApp message template looked up by its unique name.
 * "Template não encontrado." (not found) cases are emitted via sendError().
 */
import type { WhatsappMessageTemplates_BuscaPorNomeRow } from './WhatsappMessageTemplates_BuscaPorNomeRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type WhatsappMessageTemplates_BuscaTemplatePorNomeResponseDados = WhatsappMessageTemplates_BuscaPorNomeRow;

export type WhatsappMessageTemplates_BuscaTemplatePorNomeResponse = ApiResponse<WhatsappMessageTemplates_BuscaTemplatePorNomeResponseDados>;

registerResponseContract('WhatsappMessageTemplates_BuscaTemplatePorNomeResponse', {
  template_id:        { type: 'number',  required: true },
  template_name:      { type: 'string',  required: true },
  template_content:   { type: 'string',  required: true },
  template_type:      { type: 'string',  required: true },
  template_media_url: { type: 'string',  required: false },
  is_active:          { type: 'number',  required: true },
  created_at:         { type: 'string',  required: true },
  updated_at:         { type: 'string',  required: true },
})
